module.exports = __webpack_public_path__ + "img/ghmghm.27ca8b64.png";